<template>
  <v-bottom-sheet v-model="showModal" dark :persistent="true">
    <v-card color="grey darken-4" dark class="pa-4">
      <div id="gift_select">
        <div class="giftSelectHeader">
          <div class="giftSelectTitle">
            {{ $t("hybrid_settings.premium_livestream_gift_title") }}
          </div>
          <div class="giftSelectSubtitle">
            {{ $t("hybrid_settings.premium_livestream_gift_subtitle") }}
          </div>
        </div>
        <Carousel
          :perPage="1"
          :paginationSize="6"
          :paginationPadding="3"
          :paginationColor="'#ffffffb3'"
          :paginationActiveColor="'#fff'"
          v-model="currentSlide"
        >
          <Slide v-for="(page, index) in gift_carousel" :key="index">
            <div class="giftCarouselPage">
              <div
                v-for="gift in page"
                :key="gift.gift_id"
                class="giftCarouselWrapper"
              >
                <div
                  :class="{
                    giftCarouselItem: true,
                    selected:
                      selectedGift && gift.gift_id == selectedGift.gift_id,
                  }"
                  @click="clickGift(gift)"
                >
                  <img
                    class="giftImage"
                    :src="gift.image"
                    :loading="index === currentSlide ? 'eager' : 'lazy'"
                  />
                  <div class="giftCost">
                    <img src="@/assets/img/coin.svg" /> {{ gift.cost }}
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        </Carousel>
        <hr class="carouselDivider" />
        <div class="bottomBar">
          <div class="selectedGiftCost" v-if="selectedGift">
            <div class="selectedGiftCostCoinWrapper">
              <img src="@/assets/img/coin.svg" />
            </div>
            {{ selectedGift.cost }}
          </div>
          <div
            class="bottomBarButton continueButton"
            v-if="continueMode"
            @click="doneButton"
          >
            {{ $t("hybrid_settings.continue_button") }}
          </div>
          <div
            class="bottomBarButton selectGiftButton"
            v-else
            @click="doneButton"
          >
            {{ $t("hybrid_settings.select_gift_button") }}
          </div>
        </div>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import _ from "lodash";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "GiftSelectModal",
  components: {
    Carousel,
    Slide,
  },
  props: ["value", "gifts", "continueMode"],
  watch: {
    showModal: function (newVal) {
      this.$emit("input", newVal);
    },
    value: function (newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.gift_carousel = [];
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateCarousel();
          }, 100);
        });
      } else {
        this.updateCarousel();
      }
    },
  },
  data() {
    return {
      showModal: false,
      selectedGift: null,
      gift_carousel: [],
      currentSlide: 0,
    };
  },
  created() {
    this.updateCarousel();
  },
  methods: {
    updateCarousel() {
      this.selectedGift = this.gifts[0];
      this.gift_carousel = _.chunk(this.gifts, 8);
    },
    clickGift(gift) {
      console.log("clickGift gift", gift);
      this.selectedGift = gift;
    },
    doneButton() {
      this.$emit("done", this.selectedGift);
    },
  },
};
</script>

<style lang="scss" scoped>
#gift_select {
  background: black;
  color: white;
  font-family: Avenir;
  user-select: none;
}

.giftSelectHeader {
  padding: 14px 20px 20px;
  text-align: center;
  .giftSelectTitle {
    font-family: Avenir-Heavy;
    font-size: 16px;
  }
  .giftSelectSubtitle {
    font-size: 13px;
  }
}

::v-deep .VueCarousel-pagination .VueCarousel-dot {
  margin: 0 !important;
  transform: scale(0.8);
  transform-origin: center center; /* or top left, etc. */
}
::v-deep .VueCarousel-pagination .VueCarousel-dot-container {
  background: black;
  padding: 0 10px;
}
::v-deep .VueCarousel-pagination .VueCarousel-dot--active {
  margin: 0 !important;
  transform: scale(1);
}

.carouselDivider {
  height: 1px;
  margin: 0;
  margin-top: -8px;
  background: rgba(157, 157, 157, 0.2);
  margin-bottom: 20px;
}

.giftCarouselPage {
  display: flex;
  flex-wrap: wrap;
  width: 100vw;
}
.giftCarouselWrapper {
  flex: 0 0 25%; /* 4 columns = 25% */
  display: flex;
  justify-content: center;
}
.giftCarouselItem {
  border-radius: 10px;
  padding: 8px 0;
  &.selected {
    background-color: rgba(255, 255, 255, 0.15);
  }
  .giftImage {
    width: 60px;
    height: 60px;
    margin: 0 8px;
    border-radius: 10px;
  }
  .giftCost {
    width: 100%;
    text-align: center;
    font-size: 13px;
    img {
      width: 12px;
      height: 12px;
      margin-bottom: -1px;
    }
  }
}

.bottomBar {
  display: flex;
  justify-content: space-between;
  padding: 0 28px max(30px, env(safe-area-inset-bottom));
  gap: 20px;
  .selectedGiftCost {
    display: flex;
    justify-content: center;
    flex-direction: column;
    .selectedGiftCostCoinWrapper {
      display: flex;
      justify-content: center;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
  .bottomBarButton {
    flex-grow: 1;
    font-family: Avenir-Heavy;
    font-size: 16px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-radius: 22px;
    &.selectGiftButton {
      background-color: #0095ff;
    }
    &.continueButton {
      color: black;
      background-image: linear-gradient(
        20deg,
        #805020 -5%,
        #a37e41 7%,
        #c8b064 20%,
        #e3d47e 33%,
        #f3ea8d 45%,
        #f9f293 57%,
        #f4ea8a 69%,
        #e7d472 81%,
        #d2b14a 89%,
        #c3982e 95%
      );
    }
  }
}
</style>
